import CircularProgress from "@mui/material/CircularProgress";
import { ComponentProps } from "../types";

function Component({ component }: ComponentProps) {
	return <CircularProgress key={component.id} />;
}

export default Component;
